<template>
  <div class="col-12 mb-2 mb-lg-0 row">
    <div
      v-bind:class="{
        'text-md-left': variantLeft,
        'text-md-right': variantCenter
      }"
      class="col-12 col-md-6 text-center"
    >
      {{ itemDate }}
    </div>
    <div class="col-12 col-md-6 text-center text-md-left">
      <a
        v-if="item.link_to_website"
        v-bind:href="item.link_to_website"
        target="_blank"
      >
        <b-icon-box-arrow-up-right variant="primary" class="mr-1" />
      </a>
      <HostBadge v-bind:hostName="item.host" prefix class="mr-1" />
      <span class="name">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import HostBadge from "@/components/HostBadge";

export default {
  name: "CalendarItem",
  props: {
    variant: {
      default: "left"
    },
    item: {}
  },
  components: {
    HostBadge
  },
  computed: {
    itemDate() {
      return this.$moment(this.item.event_time).format("YYYY-MM-DD HH:mm");
    },
    variantLeft() {
      return this.variant === "left";
    },
    variantCenter() {
      return this.variant === "center";
    }
  }
};
</script>
